import React from 'react';
import { connect } from 'react-redux'
import { FormattedMessage, FormattedDate, FormattedTime } from 'react-intl';
import ReactTooltip from 'react-tooltip'
import { Link } from 'react-router';

class CartUserPrintList extends React.Component {

    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.props.checkSubcomponentMounted ? this.props.checkSubcomponentMounted() : null;
    }

    render() {

        const { items, deleteCartItem } = this.props;

        if (items.length === 0) {
            return <p><FormattedMessage id="TEXT_CART_EMPTY" /></p>
        } else {

            const linkToZipDownload = '/api/shoppingcart-zipdownload?webquality=0&printmarks=1';

            return (

                <div className="panel-body table-responsive user-print-list-table">
                    <p><FormattedMessage id="TEXT_CART_INTRO_USER_PRINT"/></p>
                    <div className="panel">
                        <table className="table table-sm table-striped table-hover">
                            <thead>
                            <tr>
                                <th><FormattedMessage id="LABEL_TITLE"/></th>
                                <th><FormattedMessage id="LABEL_CAMPAIGN"/></th>
                                <th><FormattedMessage id="LABEL_LANGUAGE"/></th>
                                <th><FormattedMessage id="LABEL_AUTHOR"/></th>
                                <th><FormattedMessage id="LABEL_UPDATED_AT"/></th>
                                <th></th>
                                <th></th>
                            </tr>
                            </thead>

                            <tbody>
                            {
                                items.map((item, i) => {

                                    const configuratorRoute = '/configurator/' + item.documentId + '/' + item.documentStorageId + '/0';

                                    return <tr key={i}>
                                        <td>{ item.storageName }</td>
                                        <td>{ item.campaign }</td>
                                        <td><FormattedMessage id={'LANGUAGE_' + item.locale}/></td>
                                        <td>{ item.author }</td>
                                        <td><FormattedDate value={ item.storageUpdatedAt } /> - <FormattedTime value={ item.storageUpdatedAt } /></td>
                                        <td>
                                            <Link to={configuratorRoute}>
                                                <FormattedMessage id="LABEL_TO_CONFIGURATOR">
                                                    {(message) => (
                                                        <i className="material-icons"
                                                           data-tip={ message }>create</i>
                                                    )}
                                                </FormattedMessage>
                                            </Link>
                                            <ReactTooltip />

                                        </td>
                                        <td>
                                            <FormattedMessage id="LABEL_CART_DELETE">
                                                {(message) => (
                                                    <a onClick={() => { deleteCartItem(item.documentStorageId) }}>
                                                        <i className="material-icons" data-tip={ message }>remove_shopping_cart</i>
                                                    </a>
                                                )}
                                            </FormattedMessage>
                                            <ReactTooltip />
                                        </td>
                                    </tr>
                                })
                            }
                            </tbody>
                        </table>
                    </div>
                    <br />
                    <a href={linkToZipDownload} role="button" className="btn btn-success" target="_blank">
                        <FormattedMessage id="LABEL_DOWNLOAD_CART_ZIP" />
                    </a>
                </div>
            );
        }
    }
}

export default connect(state => ({ documentStorage: state.documentStorage, app: state.app }))(CartUserPrintList);


// WEBPACK FOOTER //
// ./src/js/components/CartUserPrintList.react.jsx